import {
  LayoutDashboard,
  LogOut,
  Music,
  PlusSquare,
  Settings,
  PenTool,
} from "lucide-react";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AppDomain } from "../../lib/data";

const Sidebar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return (
      location.pathname === path ||
      (path !== "/d" && location.pathname.startsWith(path))
    );
  };

  const navItems = [
    { icon: LayoutDashboard, label: "Overview", path: "/d" },
    { icon: Music, label: "Hymns", path: "/d/hymns" },
    { icon: PlusSquare, label: "Create Hymn", path: "/d/create-hymn" },
    { icon: PenTool, label: "Signatures", path: "/d/signatures" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("t");
    window.location.href = "/login";
  };

  return (
    <div className="w-64 min-h-screen bg-black border-r border-gray-800 flex flex-col fixed left-0 top-0 z-50">
      {/* Brand */}
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-xl font-bold">
          <span className="text-white">Admin</span>
          <span className="text-purple-500 ml-1">Portal</span>
        </h1>
        <p className="text-xs text-gray-500 mt-1">{AppDomain}</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-6 px-3 space-y-1">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
              isActive(item.path)
                ? "bg-purple-500/10 text-purple-400"
                : "text-gray-400 hover:bg-gray-800/50 hover:text-white"
            }`}
          >
            <item.icon
              className={`w-5 h-5 ${
                isActive(item.path)
                  ? "text-purple-400"
                  : "text-gray-500 group-hover:text-white"
              }`}
            />
            <span className="font-medium text-sm">{item.label}</span>
            {isActive(item.path) && (
              <div className="ml-auto w-1.5 h-1.5 rounded-full bg-purple-400 shadow-[0_0_8px_rgba(168,85,247,0.5)]" />
            )}
          </Link>
        ))}
      </nav>

      {/* Footer Actions */}
      <div className="p-4 border-t border-gray-800 space-y-2">
        <button className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-gray-400 hover:bg-gray-800/50 hover:text-white transition-all duration-200">
          <Settings className="w-5 h-5 text-gray-500" />
          <span className="font-medium text-sm">Settings</span>
        </button>
        <button
          onClick={handleLogout}
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-500/10 transition-all duration-200"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium text-sm">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
